import React from 'react';
import axios from 'axios';

import AppVars from '../../AppVars.js'
import Logger from '../../Logger.js';
import { constants } from '../../constants/constants';
import EmailSentView from '../Views/TO/Reset/EmailSentView';


let appVars = AppVars.getInstance();
let logger = Logger.getInstance()

class EmailSent extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
            loadingReset: false
        }
        this.sendEmail = this.sendEmail.bind(this)
    }

    async sendEmail() {
        let dest = this.props.loginURI
        var email = this.props.email.trim();
        this.setState({
            loadingReset: true
        });
        await axios({
            headers: {
                'X-BRAND': 'T',
                "x-client" : "FR-Portal-Toyota",
                //"x-client" : "SI-REG"
            },
            method: 'post',
            url: appVars.getAPIGatewayURL() + "/password/" + email,
            // url: '/v2/admin/customer/password/' + email,
            /*headers: {
                'X-API-KEY': await appVars.getAPIKey(),
                'X-BRAND': 'T',
                'X-CLIENT': 'SI-REG',
                'X-VERSION': '1.6',
                'Content-Type': 'application/json',
            }, */
            data: {
                'redirectURI': dest
            }
        })
        .then((resp) => this.handleDCS3Response(resp))
        .catch((err) => this.handleDCS3Error(err))
    }

    handleDCS3Response(resp) {
        // Following along with the DCS3 repo
        this.setState({
            loadingReset: false
        })
        this.props.displayForm("SENT")
    }

    handleDCS3Error(err) {
        logger.log('stage', err)
        let error = err.response.data
        logger.log('stage', error)
        if (error.status.code == '400') {
            if (typeof error['status']['messages'] !== 'undefined') {
                if (error['status']['messages'][0]['code'] == constants.INACTIVATED_EMAIL_ID) {
                    this.setState({
                        loadingReset: false
                    })
                    this.props.displayForm("INACTIVE")
                    // this.passwordStateService.changeState('INACTIVE');
                }
            } else {
                if (this.props.showForm === "ERROR") {
                    this.setState({
                        loadingReset: false
                    });
                    this.props.displayForm("FAILURE")
                } else {
                    this.setState({
                        loadingReset: false
                    });
                    this.props.displayForm("ERROR")
                }
            }
        } else {
            if (this.props.showForm === "ERROR") {
                this.setState({
                    loadingReset: false
                });
                this.props.displayForm("FAILURE")
            } else {
                this.setState({
                    loadingReset: false
                });
                this.props.displayForm("ERROR")
            }
        }
    }

    render() {
        return(
            <EmailSentView
            email = {this.props.email}
            loadingReset = {this.state.loadingReset}
            sendEmail = {this.sendEmail}
            style = {this.props.style}
            />
        )
    }
}

export default EmailSent;